<template>
  <table
    class="previewPartContainer"
    :class="{partsContainerHover:showHoverMenu, partsContainerChoose: isChoose}"
    @mouseover="setHoverState(true)"
    @mouseleave="setHoverState(false)"
    @click="partsContainerEditButton(partsContainer.section_id, partsContainer.id)"
  >
    <tbody>
      <tr>
        <!-- 部品にマウスオーバーで出てくる領域 -->
        <template v-if="showHoverMenu">
          <div class="partsContainerWindow__left">
            <span class="partsWindow__left__move hover-icon">
              <i class="fas fa-arrows-alt"></i>
            </span>
          </div>
          <ul class="partsContainerWindow__right">
            <li @click="partsContainerEditButton(partsContainer.section_id, partsContainer.id)" class="hover-icon">
              <i class="fas fa-edit"></i>
            </li>
            <li @click="partsContainerCopyButton($event, partsContainer.section_id, partsContainer.id)" class="hover-icon">
              <i class="fas fa-clone"></i>
            </li>
            <li @click="partsContainerDeleteConfirmButton(partsContainer.section_id, partsContainer.id)" class="hover-icon">
              <i class="fas fa-trash-alt"></i>
            </li>
          </ul>
        </template>
        <td
          :class="{ editing: isEditing, 'editing-error': isCodePartError }"
          :style="partsContainerOuterStyles"
        >
          <!-- パーツコンテナの外枠 -->
          <table :style="[defaultWidth, partsContainerHorizontalStyles]">
            <tbody>
              <tr>
                <!-- フォローボタン用のパーツコンテナ -->
                <preview-parts-container-follow-button
                  v-if="partsContainer.type === 'FollowButton' || partsContainer.type === 'Share'"
                  :partsContainer="partsContainer"
                  :sectionId="sectionId"
                  :contentsWidth="contentsWidth"
                />
                <!-- 画像カード用のパーツコンテナ -->
                <preview-parts-container-image-card
                  v-else-if="partsContainer.type === 'ImageCard'"
                  :partsContainer="partsContainer"
                  :sectionId="sectionId"
                  :partWidth="partWidth()"
                  :defaultWidth="defaultWidth"
                />
                <!-- 縦レイアウト -->
                <template v-else-if="partsContainer.layout_type === 'vertical'">
                  <td :style="partWidth()">
                    <table style="width: 100%;">
                      <tbody>
                        <tr>
                          <td style="width: 100%;" :style="partsContainerInnerStyles">
                            <table style="width: 100%;">
                              <tbody>
                                <!-- table_countの数だけ、tr要素を作る -->
                                <tr style="width: 100%;" v-for="table_count in partsContainer.table_count" :key="table_count">
                                  <!-- table_countのループ数と、table_idが一致するものをループして、td要素を作る -->
                                  <td
                                    v-for="partsContainerPart in partsContainerParts(table_count)"
                                    :key="partsContainerPart.order_id"
                                    :style="verticalAlignStyle"
                                  >
                                    <!-- パーツ個別の表示 -->
                                    <table
                                      is="preview-part"
                                      :part="partsContainerPart"
                                      :partsContainerId="partsContainer.id"
                                      :sectionId="sectionId"
                                      :columnCount="columnCount"
                                      :partWidth="partWidth(partsContainerPart)"
                                      :partsContainerType="partsContainer.type"
                                      :partsContainerLayoutType="partsContainer.layout_type"
                                      :partsContainerStyles="partsContainer.styles"
                                      :partsContainerShareText="partsContainer.share_text"
                                      :imageCardHorizontalDisplayRatio="null"
                                      style="width: 100%;"
                                      class="partsContainer, partsContainerDefault"
                                      @updateSectionHeight="$emit('updateSectionHeight')"
                                      @updateEditingColor="isCodePartError = $event"
                                    >
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </template>
                <!-- 横レイアウト -->
                <template v-else-if="partsContainer.layout_type === 'horizontal'">
                  <!-- table_countの数だけ、td要素を作る -->
                  <td
                    v-for="table_count in partsContainer.table_count"
                    :key="table_count"
                    :style="verticalAlignStyle"
                  >
                    <!-- table_countのループ数と、table_idが一致するものをループして、テーブルを作る -->
                    <table
                      v-for="partsContainerPart in partsContainerParts(table_count)"
                      :key="partsContainerPart.order_id"
                      style="width: 100%;"
                    >
                      <tbody>
                        <tr>
                          <td>
                            <!-- パーツ個別の表示 -->
                            <table
                              is="preview-part"
                              :part="partsContainerPart"
                              :partsContainerId="partsContainer.id"
                              :sectionId="sectionId"
                              :columnCount="columnCount"
                              :partWidth="partWidth(partsContainerPart)"
                              :partsContainerType="partsContainer.type"
                              :partsContainerLayoutType="partsContainer.layout_type"
                              :partsContainerStyles="partsContainer.styles"
                              :partsContainerShareText="partsContainer.share_text"
                              :imageCardHorizontalDisplayRatio="null"
                              :style="partsContainer.type === 'ImageText' ? partWidth(partsContainerPart) : 'width: 100%;'"
                              class="partsContainer, partsContainerDefault"
                              @updateSectionHeight="$emit('updateSectionHeight')"
                              @updateEditingColor="isCodePartError = $event"
                            >
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
    <portal v-if="deleteConfirm.isShow" to="modal1">
      <modal ref="modal" @close="deleteConfirm.isShow = false">
        <template slot="title">削除確認</template>
        <template slot="name">本当にパーツを削除してもよろしいですか</template>
        <template slot="submit">
          <div class="button-box">
            <button type="button" @click="partsContainerDelete" class="delete normal-btn">削除</button>
            <button type="button" @click="deleteConfirm.isShow = false" class="cancel normal-btn">キャンセル</button>
          </div>
        </template>
      </modal>
    </portal>
  </table>
</template>

<script>
import PreviewPartsContainerFollowButton from '@/components/Content/Preview/PreviewPartsContainer/PreviewPartsContainerFollowButton'
import PreviewPartsContainerImageCard from '@/components/Content/Preview/PreviewPartsContainer/PreviewPartsContainerImageCard'
import PreviewPart from '@/components/Content/Preview/PreviewPart'
import Modal from '@/components/Util/Modal'

export default {
  name: 'previewPartsContainer',
  props: [
    'partsContainer',
    'sectionId',
    'draggingSectionPadding',
    'columnCount',
    'isChoose',
  ],
  data () {
    return {
      hoverActive: false,
      deleteConfirm: {
        isShow: false,
        sectionId: null,
        partsContainerId: null
      },
      isEditing: false,
      isCodePartError: false,
    }
  },
  components: {
    PreviewPartsContainerFollowButton,
    PreviewPartsContainerImageCard,
    PreviewPart,
    Modal,
  },
  methods: {
    setHoverState (state = false) {
      // パーツコンテナホバーメニューの表示切り替え
      this.hoverActive = state
      // パーツコンテナメニュー表示中はセクションのホバーメニューを非表示
      this.$emit('toggleSectionHoverState', state)
    },
    // パーツ編集ボタン
    partsContainerEditButton (sectionId, partsContainerId) {
      const partsContainer = this.$store.getters.findPartsContainer(sectionId, partsContainerId)
      const partsContainerType = partsContainer ? partsContainer.type : null
      if (!partsContainerType) return
      // パレットをひらく
      this.$store.commit('updateStatusPalette', { partsContainerType, sectionId, partsContainerId })
    },
    async partsContainerCopyButton ($event, sectionId, partsContainerId) {
      // ボタンを連打すると partsContainerId が重複してしまうため、処理が終わるまでマウスオーバー領域を隠す
      this.hoverActive = false

      // 複製したいパーツコンテナの元を取得(deep copy)
      const copyPartsContainer = JSON.parse(JSON.stringify(this.$store.getters.findPartsContainer(sectionId, partsContainerId)))
      const newPartId = this.$store.getters.partsMaxId + 1
      const privateBucketUrls = this.$utils.image.getMultiplePrivateBucketUrl()
      const parts = await Promise.all(copyPartsContainer.parts.map(async (part, index) => {
        // パーツコンテナに含まれているパーツにidを振り直す
        part.id = newPartId + index

        // 画像パーツであり、空画像ではない場合、新しい画像URL等をセット
        if (part.type === 'Image' && part.attrs['data-key']) {
          return {
            ...part,
            attrs: await this.getNewImageAttrs(part.attrs)
          }
        } else if (part.type === 'Code' && part.attrs && part.body) {
          let body = part.body
          const attrs = await Promise.all(part.attrs.map(async attr => {
            if (!attr['data-key']) return attr
            let newAttr = await this.getNewImageAttrs(attr)
            if (!attr['data-external-url']) {
              // 内部画像のみ src=""置換
              const regSrc = new RegExp(`src="(${privateBucketUrls[0]}|${privateBucketUrls[1]})/${attr['data-key']}\\S+"`, 'g')
              body = body.replace(regSrc, 'src="' + newAttr.src + '"')
            }
            // data-image-key置換
            const regImageKey = new RegExp(`data-image-key="${attr['data-image-key']}"`, 'g')
            body = body.replace(regImageKey, `data-image-key="${newAttr['data-image-key']}"`)

            return { ...newAttr, body }
          }))
          return {
            ...part,
            attrs,
            body,
          }
        } else {
          return part
        }
      }))

      // 複製するパーツコンテナのIDを作成：今あるパーツコンテナの最大id + 1
      const newPartsContainerId = this.$store.getters.partsContainersMaxId + 1
      // 複製するパーツコンテナを作成：order_idは後で設定するので、空欄で追加しておく
      const newPartsContainer = {
        id: newPartsContainerId,
        type: copyPartsContainer.type,
        display_name: copyPartsContainer.display_name,
        section_id: copyPartsContainer.section_id,
        order_id: '',
        column_count: copyPartsContainer.column_count,
        layout_type: copyPartsContainer.layout_type,
        horizontal_display_ratio: copyPartsContainer.horizontal_display_ratio,
        src_type: copyPartsContainer.src_type,
        table_count: copyPartsContainer.table_count,
        flg_side: copyPartsContainer.flg_side,
        flg_image_content_mobile_full_width: copyPartsContainer.flg_image_content_mobile_full_width,
        share_text: copyPartsContainer.share_text,
        parts: parts,
        styles: copyPartsContainer.styles,
      }
      // 複製したいパーツコンテナの後ろに、新しいパーツコンテナを追加
      this.$store.commit('appendPartsContainer', {
        sectionId,
        partsContainerId,
        newPartsContainer
      })

      // order_idの番号を並び替え
      this.$store.commit('sortPartsContainers', {})
      // 高さをPreviewSectionで再計算
      this.$emit('updateSectionHeight')
      // マウスオーバー領域を表示する
      this.hoverActive = true
    },
    async getNewImageAttrs (attrs) {
      const formData = new FormData()
      formData.append('key', attrs['data-key'])
      formData.append('contentId', this.$route.params.id)
      formData.append('tmpUuid', this.$store.state.contentTmpUuid)

      if (attrs['data-external-url']) {
        formData.append('externalUrl', attrs['data-external-url'])
      }

      const json = await this.$http({
        url: '/image/copy_tmp_image',
        type: 'POST',
        params: formData,
      })
      if (json && json.status === 200) {
        let image = json.data.image
        image = { ...image, url: decodeURIComponent(image.url) }

        // contentImagesもコピー
        const contentImage = this.$store.state.contentImages[attrs['data-key']]
        this.$store.commit('mergeContentImages', { [image.key]: contentImage })
        // key系だけを更新
        return {
          ...attrs,
          src: image.url,
          'data-key': image.key,
          'data-image-key': this.$utils.image.getImageKey(image.key)
        }
      }
    },
    partsContainerDeleteConfirmButton (sectionId, partsContainerId) {
      this.deleteConfirm = {
        isShow: true,
        sectionId,
        partsContainerId,
      }
    },
    partsContainerDelete () {
      const { sectionId, partsContainerId } = this.deleteConfirm
      this.$store.dispatch('deletePartsContainer', {
        sectionId: sectionId,
        partsContainerId: partsContainerId
      })
      // 高さをPreviewSectionで再計算
      this.$emit('updateSectionHeight')
    },
  },
  computed: {
    showHoverMenu () {
      return this.hoverActive && !this.draggingSectionPadding
    },
    // メール全体の幅
    contentsWidth () {
      return this.$store.getters.noUnitScssVars.contentsWidth
    },
    // メール全体の幅
    defaultWidth () {
      return {
        'width': this.contentsWidth + 'px'
      }
    },
    // メールの、一番外側のtd要素の数
    tdCount () {
      if (!this.partsContainer) return
      // 縦なら1つ、横ならtable_countの数
      let tdCount
      if (this.partsContainer.layout_type === 'vertical') {
        tdCount = 1
      } else if (this.partsContainer.layout_type === 'horizontal') {
        tdCount = this.partsContainer.table_count
      }
      return tdCount
    },
    // パーツ個別の幅
    partWidth: function () {
      return function (partsContainerPart) {
        if (!this.partsContainer) return null
        // パーツコンテナの左右余白
        const paddingLeft = this.partsContainer.styles['padding-left'] ? Number(this.partsContainer.styles['padding-left'].replace('px', '')) : 0
        const paddingRight = this.partsContainer.styles['padding-right'] ? Number(this.partsContainer.styles['padding-right'].replace('px', '')) : 0
        // スペーサーの合計幅
        let spacerWidth = 0
        let spacerParts
        if (this.partsContainer.layout_type === 'horizontal' && this.partsContainer.type !== 'ImageText' && this.partsContainer.type !== 'ImageCard') {
          // 横レイアウトで、画像テキスト以外：全スペーサーを取得
          spacerParts = this.partsContainer.parts.filter(part => part.type === 'Spacer')
        } else if (this.partsContainer.layout_type === 'horizontal' && this.partsContainer.type === 'ImageText') {
          // 横レイアウトで、画像テキスト
          if (partsContainerPart.type === 'Spacer') {
            return {
              'width': partsContainerPart.attrs.width
            }
          } else {
            const imagePart = this.partsContainer.parts.filter(part => part.type === 'Image')
            if (imagePart.length === 1) {
              spacerParts = this.partsContainer.parts.filter(part => part.type === 'Spacer')
              const displayRatio = this.partsRatiofromTheWhole(this.partsContainer.horizontal_display_ratio, partsContainerPart.type)
              const returnWidth = ((this.contentsWidth - paddingLeft - paddingRight - Number(spacerParts[0].attrs.width.replace('px', ''))) * displayRatio).toFixed(3)
              return {
                'width': returnWidth + 'px'
              }
            } else if (imagePart.length >= 2) {
              spacerParts = this.partsContainer.parts.filter(part => part.type === 'Spacer' && part.order_id === 1)
            }
          }
        } else if (this.partsContainer.layout_type === 'vertical' && this.partsContainer.type === 'ImageText') {
          // 縦レイアウトで、画像テキスト
          if (!partsContainerPart) return { 'width': this.defaultWidth }
          if (partsContainerPart.type === 'Spacer') {
            return {
              'width': partsContainerPart.attrs.width
            }
          } else {
            const imagePart = this.partsContainer.parts.filter(part => part.type === 'Image')
            if (imagePart.length >= 2) {
              spacerParts = this.partsContainer.parts.filter(part => part.type === 'Spacer' && part.order_id === 1)
              // 間隔の調整で0のときはスペーサーパーツがない
              spacerWidth = spacerParts.length ? Number(spacerParts[0].attrs.width.replace('px', '')) : 0
              const displayRatio = this.partsRatiofromTheWhole(this.partsContainer.horizontal_display_ratio, partsContainerPart.type)
              const returnWidth = ((this.contentsWidth - paddingLeft - paddingRight - spacerWidth) * displayRatio).toFixed(3)
              return {
                'width': returnWidth + 'px'
              }
            }
          }
        } else if (this.partsContainer.layout_type === 'horizontal' && this.partsContainer.type === 'ImageCard') {
          // 横レイアウトで、画像カード
          // 画像カードの横並びは比率調整のため複数パーツの合計幅を返す
          // 全スペーサーを取得
          spacerParts = this.partsContainer.parts.filter(part => part.type === 'Spacer')
          return {
            // パーツ合計幅 = メールの幅 - パーツコンテナ左右の余白 - スペーサーの合計幅
            'width': (this.contentsWidth - paddingLeft - paddingRight - spacerWidth) + 'px',
          }
        }
        // 取得したスペーサーの幅を合計する
        if (spacerParts && spacerParts.length > 0) {
          spacerParts.forEach(spacerPart => {
            spacerWidth += spacerPart.attrs.width ? Number(spacerPart.attrs.width.replace('px', '')) : 0
          })
        }
        const columnCount = this.partsContainer.type === 'ImageGroup' && this.partsContainer.layout_type === 'vertical' ? 1 : this.partsContainer.column_count
        return {
          // パーツ1個の幅 = ( メールの幅 - パーツコンテナ左右の余白 - スペーサーの合計幅 ) / カラム数
          'width': (this.contentsWidth - paddingLeft - paddingRight - spacerWidth) / columnCount + 'px',
        }
      }
    },
    partsRatiofromTheWhole () {
      return (horizontalDisplayRatio, partType) => {
        switch (horizontalDisplayRatio) {
          case 'imageOneToTextOne':
            return 1 / 2
          case 'imageTwoToTextOne':
            return partType === 'Image' ? 2 / 3 : 1 / 3
          case 'imageOneToTextTwo':
            return partType === 'Image' ? 1 / 3 : 2 / 3
          case 'imageOneToTextThree':
            return partType === 'Image' ? 1 / 4 : 3 / 4
          default:
            return 1 / 2
        }
      }
    },
    // パーツコンテナの中身を、テーブルIDでフィルターして返す
    partsContainerParts () {
      return function (tableId) {
        // 並び順を変更したら画面を再描画させるため、中身のパーツをorder_id順でソートする
        return this.partsContainer.parts.filter(part => part.table_id === tableId).sort((a, b) => {
          if (a.order_id < b.order_id) return -1
          if (a.order_id > b.order_id) return 1
          return 0
        })
      }
    },
    partsContainerHorizontalStyles () {
      if (!this.partsContainer || this.partsContainer.type === 'FollowButton' || this.partsContainer.type === 'ImageCard') return null
      if (this.partsContainer.layout_type === 'vertical') return null
      const styles = this.partsContainer.styles
      return {
        'padding-top': styles['padding-top'] || null,
        'padding-right': styles['padding-right'] || null,
        'padding-bottom': styles['padding-bottom'] || null,
        'padding-left': styles['padding-left'] || null,
      }
    },
    partsContainerInnerStyles () {
      // outer-background以外のスタイル
      const styles = JSON.parse(JSON.stringify(this.partsContainer.styles))
      if (styles['outer-background']) {
        delete styles['outer-background']
      }
      return styles
    },
    partsContainerOuterStyles () {
      // outer-background
      if (!this.partsContainer || !this.partsContainer.styles['outer-background']) return null
      return {
        'background': this.partsContainer.styles['outer-background']
      }
    },
    // 垂直方向位置のスタイル
    verticalAlignStyle () {
      if (!this.partsContainer) return null
      // スタイルが登録されていたらその値、なければtopを設定
      const value = this.partsContainer.styles['vertical-align'] ? this.partsContainer.styles['vertical-align'] : 'top'
      return { 'vertical-align': value }
    },
    editingPartsContainer () {
      return this.$store.state.status.palette
    }
  },
  watch: {
    'partsContainer.column_count' (value) {
      this.$emit('updateSectionHeight')
    },
    editingPartsContainer (paletteStatus) {
      if (paletteStatus.sectionId === this.sectionId && paletteStatus.partsContainerId === this.partsContainer.id) {
        this.isEditing = true
      } else {
        this.isEditing = false
      }
    }
  },
}
</script>

<style lang="scss" scoped>
/* パーツコンテナテーブル */
/* align または margin が反映されなかった場合用に両方指定 */
.previewPartContainer {
  margin-left: 'auto';
  margin-right: 'auto';
  margin: 5px 0;
  position: relative;
  .editing {
    outline: 2px solid rgba(35,24,21,0.75);
    outline-offset: -2px;
  }
  .editing-error {
    outline-color:#dd6a59;
  }
}

/* パーツコンテナ */
.partsContainer {
  padding: 10px;
  position: relative; /* マウスホバー時の表示のために必要 */
  /* ダミーパーツ */
  &--dummy {
  width: $contentsWidth;
  text-align: center;
  -moz-user-select: none; /* ドラッグで選択できないように */
  -khtml-user-select: none;
  -webkit-user-select: none
  }
}

/* パーツコンテナのマウスホバーされていない時の枠 */
.partsContainerDefault {
  /* マウスホバー時と同じ設定をしておく、これがないとセクションリサイズの minHeight が
     セクションの高さより大きくなってしまい、無限に小さくリサイズできてしまう。 */
  user-select: none;
  padding: 0;
  margin: 0;
}

/* パーツコンテナにマウスホバーで表示される枠：外側 */
.partsContainerHover {
  outline: 2px solid #5496E8;
  position: relative;
  z-index: 10;
}
/* ドラッグ中 */
.partsContainerChoose {
  outline-offset: -2px;
}

/* パーツコンテナにマウスホバーで表示される枠：内側 */
.partsContainerWindow {
  /* 枠の右側：編集、複製、削除ボタン */
  &__right {
    position: absolute;
    top: -20px;
    left: calc(100% - 20px);
    padding: 20px 0 0 20px;
    width: 50px;
    height: 120px;
    margin: 0;
    /* 編集、複製、削除ボタン */
    li {
      display: block;
      list-style-type: none;
    }
    .hover-icon {
      padding: 4px 6px 4px 10px;
    }
  }
  &__left {
    position: absolute;
    color: #fff;
    // 移動アイコン
    .hover-icon {
      display: inline-block;
      padding: 4px 6px 4px 6px;
    }
  }
}
.hover-icon {
  line-height: 0;
  user-select: none;
  color: #5496E8;
  opacity: 0.6;
  font-size: 24px;
  cursor: pointer;
  filter: drop-shadow(2px 2px 1px rgba(198, 198, 198, 0.5));
  transition: all 0.3s ease 0s;
  /* ボタンにカーソル乗せた時 */
  &:hover {
    opacity: 1;
  }
}

// モーダルの中身
.button-box {
  display: flex;
  justify-content: center;
  button {
    font-size: 14px;
    border: solid 1px #c6c6c6;
    border-radius: 5px;
    &:hover {
      opacity: 0.8;
    }
    &.delete {
      margin-right: 20px;
      color: #fff;
      border: solid 1px #484848;
      background: #484848;
    }
  }
}
</style>
